import React from 'react';
import { useParams} from 'react-router-dom';

const Errors = props => {
    const { site } = useParams()
    const displayValue = `We are working to get the Digital Tier for ${site}.`

    return (
        <>
            <div className="error-container">
                <span style={{ fontSize: 'xxx-large' }}>
                    {displayValue}
                </span>
                <br />
                <span style={{ fontSize: 'xxx-large' }}>
                    Appreciate your patience.
                </span>
            </div>
            <div className="link-container">
                <a target="_blank" href="https://dop.honeywell.com/" className="more-link">Visit DOP Home</a>
                <br />
                <a target="_blank" href="https://nexus.honeywell.com/" className="more-link">Visit Nexus Home</a>
            </div>
        </>
    )
}
export default Errors